import { Navigate } from 'react-router-dom';
import NotFound from '@components/not-found/NotFound';

import MeterReadDetailsPage from '@pages/meter-read-details/MeterReadDetailsPage';
import EstimationFactorDashboardPage from '@pages/estimation-factor-dashboard/EstimationFactorDashboardPage';
import EstimateDetails from '@pages/estimation-details/EstimationDetails';
import CoreInfoPage from '@pages/core-info-page/CoreInfoPage';
import FileIngestionPage from '@pages/file-ingestion/FileIngestionPage';
import FileUploadStatus from '@pages/file-upload-status/FileUploadStatus';
import ProdStatValidateList from '@pages/prod-stat-validate-list/ProdStatValidateList';
import ProdStatDashboard from '@pages/prod-stat-dashboard/ProdStatDashboard';
import Audit from '@pages/audit/audit';
import AuditSummary from '@pages/audit-summary/AuditSummary';
import AdminOnly from '@components/admin-only/AdminOnly';
import SuperAdminOnly from '@components/super-admin-only/SuperAdminOnly';
import PreparerOnly from '@components/preparer-only/PreparerOnly';
import PreparerOrApproverOnly from '@components/preparer-or-approver-only/PreparerOrApproverOnly';
import VendorList from '@pages/vendor-list/VendorList';
import VendorForm from '@components/vendorform/VendorForm';
import DollarJournalDashboardPage from '@pages/dollar-journal-dashboard/DollarJournalDashboardPage';
import InvoicesDashboardPage from '@pages/invoices-dashboard/InvoicesDashboardPage';
import AvevaConnect from '@components/aveva/AvevaConnect';
import NspCoreInfoPage from '@pages/nsp-core-info/NspCoreInfoPage';
import DataMigrationPage from '@pages/data-migration/DataMigrationPage';
import EstimatesUploadPage from '@pages/estimates-upload/EstimatesUploadPage';
import SppReportsAccountingPage from '@pages/spp-reports-accounting/SppReportsAccountingPage';
import SppReportsInvoiceAmountsPage from '@pages/spp-reports-invoice-amounts/SppReportsInvoiceAmountsPage';
import SppReportsProdStatNetGenPage from '@pages/spp-reports-prod-stat-netgen/SppReportsProdStatNetGenPage';
import SppReportsPostProdStatNetGenPage from '@pages/spp-reports-post-prod-stat-netgen/SppReportsPostProdStatNetGenPage';
import CreateMeterPage from '@pages/core-info-page/CreateMeterPage';

// Patterns uREGISTERED_ROUTE_PATTERNStect unknown routes before rendering the layout
export const REGISTERED_ROUTE_PATTERNS = [
  /^\/login$/,
  /^\/oati(\/.*)?$/,
  /^\/file-upload-logs$/,
  /^\/prod-stat-validate-list$/,
  /^\/prod-stat-dashboard$/,
  /^\/meterreaddetails\/[^/]+$/,
  /^\/estimation-dashboard$/,
  /^\/estimation-details$/,
  /^\/core-info\/new$/,
  /^\/core-info\/[^/]+$/,
  /^\/file-upload-status\/[^/]+$/,
  /^\/vendor-list\/new$/,
  /^\/vendor-list\/edit\/[^/]+$/,
  /^\/vendor-list$/,
  /^\/audit$/,
  /^\/audit-summary$/,
  /^\/dollar-journal-dashboard$/,
  /^\/nsp-core-info$/,
  /^\/invoices-dashboard$/,
  /^\/spp-reports-accounting$/,
  /^\/spp-reports-invoice-amounts$/,
  /^\/spp-reports-prod-stat-netgen$/,
  /^\/spp-reports-post-prod-stat-netgen$/,
  /^\/aveva$/,
  /^\/data-migration$/,
  /^\/estimates-upload$/,
];

export const createRoutes = (defaultPath = '/file-upload-logs') => [
  {
    path: null,
    element: <Navigate to={defaultPath} replace />,
  },
  // Preparer only
  {
    path: '/file-upload-logs',
    element: (
      <PreparerOnly>
        <FileIngestionPage />
      </PreparerOnly>
    ),
  },
  {
    path: '/file-upload-status/:id',
    element: (
      <PreparerOnly>
        <FileUploadStatus />
      </PreparerOnly>
    ),
  },
  {
    path: '/prod-stat-validate-list',
    element: (
      <PreparerOrApproverOnly>
        <ProdStatValidateList />
      </PreparerOrApproverOnly>
    ),
  },
  {
    path: '/estimation-dashboard',
    element: (
      <PreparerOrApproverOnly>
        <EstimationFactorDashboardPage />
      </PreparerOrApproverOnly>
    ),
  },
  {
    path: '/estimation-details',
    element: (
      <PreparerOrApproverOnly>
        <EstimateDetails />
      </PreparerOrApproverOnly>
    ),
  },
  {
    path: '/audit',
    element: (
      <PreparerOrApproverOnly>
        <Audit />
      </PreparerOrApproverOnly>
    ),
  },
  {
    path: '/audit-summary',
    element: (
      <PreparerOrApproverOnly>
        <AuditSummary />
      </PreparerOrApproverOnly>
    ),
  },
  // Preparer + Approver
  {
    path: '/prod-stat-dashboard',
    element: (
      <PreparerOrApproverOnly>
        <ProdStatDashboard />
      </PreparerOrApproverOnly>
    ),
  },
  {
    path: '/dollar-journal-dashboard',
    element: (
      <PreparerOrApproverOnly>
        <DollarJournalDashboardPage />
      </PreparerOrApproverOnly>
    ),
  },
  {
    path: '/invoices-dashboard',
    element: (
      <PreparerOrApproverOnly>
        <InvoicesDashboardPage />
      </PreparerOrApproverOnly>
    ),
  },
  {
    path: '/nsp-core-info',
    element: (
      <PreparerOrApproverOnly>
        <NspCoreInfoPage />
      </PreparerOrApproverOnly>
    ),
  },
  {
    path: '/vendor-list',
    element: (
      <PreparerOrApproverOnly>
        <VendorList />
      </PreparerOrApproverOnly>
    ),
  },
  {
    path: '/vendor-list/new',
    element: (
      <PreparerOrApproverOnly>
        <VendorForm mode="add" />
      </PreparerOrApproverOnly>
    ),
  },
  {
    path: '/vendor-list/edit/:id',
    element: (
      <PreparerOrApproverOnly>
        <VendorForm mode="edit" />
      </PreparerOrApproverOnly>
    ),
  },
  {
    path: '/core-info/:id',
    element: (
      <PreparerOrApproverOnly>
        <CoreInfoPage />
      </PreparerOrApproverOnly>
    ),
  },
  {
    path: '/core-info/new',
    element: (
      <PreparerOrApproverOnly>
        <CreateMeterPage />
      </PreparerOrApproverOnly>
    ),
  },
  // All authenticated main-app users (Preparer, Approver, Reporter)
  {
    path: '/meterreaddetails/:id',
    element: <MeterReadDetailsPage />,
  },
  // SPP Reports — all authenticated main-app users (Reporter, Preparer, Approver, SuperAdmin)
  {
    path: '/spp-reports-accounting',
    element: <SppReportsAccountingPage />,
  },
  {
    path: '/spp-reports-invoice-amounts',
    element: <SppReportsInvoiceAmountsPage />,
  },
  {
    path: '/spp-reports-prod-stat-netgen',
    element: <SppReportsProdStatNetGenPage />,
  },
  {
    path: '/spp-reports-post-prod-stat-netgen',
    element: <SppReportsPostProdStatNetGenPage />,
  },
  // Admin (Approver) + SuperAdmin
  {
    path: '/aveva',
    element: (
      <AdminOnly>
        <AvevaConnect />
      </AdminOnly>
    ),
  },
  // SuperAdmin only
  {
    path: '/data-migration',
    element: (
      <SuperAdminOnly>
        <DataMigrationPage />
      </SuperAdminOnly>
    ),
  },
  {
    path: '/estimates-upload',
    element: (
      <SuperAdminOnly>
        <EstimatesUploadPage />
      </SuperAdminOnly>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];
